module.exports = __webpack_public_path__ + "static/banner-three-shape3-061bc918c2c51a7dea6a38af6d53910a.png";